import type { WorkflowExecution } from '@/hooks/useWorkflowExecutions';
import { extractUserMessageText } from '@/utils/chatHistoryTransform';

/** Matches the server-side maxLength on the PATCH schema. */
export const CHAT_TITLE_MAX_LENGTH = 120;

/**
 * Display text for a conversation. Prefers the persisted title (a user rename,
 * or the server's auto-title on the first user message) and only derives from
 * chat history when it is still null.
 */
export const titleOf = (execution: WorkflowExecution): string => {
  if (execution.title) return execution.title;

  const history = execution.workflow_execution_chat_history;
  if (!history || history.length === 0) return 'New conversation';

  const firstUserMessage = history.find(message => message.role === 'user');
  if (!firstUserMessage?.content) return 'Empty conversation';

  return extractUserMessageText(firstUserMessage.content);
};
